import { render, staticRenderFns } from "./MapboxBox.vue?vue&type=template&id=72e8a955&"
import script from "./MapboxBox.vue?vue&type=script&lang=js&"
export * from "./MapboxBox.vue?vue&type=script&lang=js&"
import style0 from "./MapboxBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VSnackbar})
